import { Login, LoginForm } from 'react-admin';
import { Box, Link, Typography } from '@mui/material';

const CustomLoginForm = props => (
    <Box
        sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: '5vh'            
        }}
    >
        <Box
            sx={{
                width: '100%',
                maxWidth: '400px',
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box
                component="img"
                src="/logo.svg"
                alt="Polfund Logo"
                sx={{
                    width: 260,
                    marginBottom: 2,
                }}
            />
            
            <Typography
                variant="h6"
                component="h1"
                sx={{
                    color: '#333333',
                    fontSize: '1.5rem',
                    marginBottom: 4,
                    textAlign: 'center',
                }}
            >
                SmartLeadAI Portal
            </Typography>

            <Box sx={{ width: '100%', mb: 1 }}>
                <LoginForm 
                    {...props}
                    sx={{
                        '& .MuiTextField-root': {
                            marginBottom: '0px !important',
                            width: '100%',
                        },
                        '& .MuiButton-root': {
                            marginTop: 2,
                            marginBottom: 1,
                            padding: '12px',
                            backgroundColor: '#E31837',
                            '&:hover': {
                                backgroundColor: '#FF1F3F',
                            },
                        },
                        '& .MuiCardContent-root': {
                            '&:last-child': {
                                paddingBottom: '14px',
                            },
                            '& > div': {
                                gap: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                            },
                        },
                    }}
                />
            </Box>
            
            <Link 
                href="/forgot-password"
                sx={{
                    color: '#E31837',
                    textDecoration: 'none',
                    fontSize: '1rem',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                }}
            >
                Zapomniałem hasła
            </Link>
        </Box>
    </Box>
);

const CustomLogin = props => (
    <Login {...props}>
        <CustomLoginForm />
    </Login>
);

export default CustomLogin; 